import _ from 'lodash';
import {FormikHelpers} from 'formik';
import {RouteComponentProps} from 'react-router-dom';
import {notify} from '@gemcook/notification';

import api from '@api';
import paths from '@paths';
import utils from '@utils';
import constants from '@constants';
import resources from '@resources';

export const signUpEmail = async (
  value: any,
  formikAction: FormikHelpers<any>,
  props: RouteComponentProps,
  reCaptchaToken: null | string
) => {
  try {
    formikAction.setSubmitting(true);
    await api.users.isLoginUsersUnique({email: value.email});

    // トークンがない
    if (_.isEmpty(reCaptchaToken)) {
      formikAction.setSubmitting(false);
      return;
    }

    // 1. チームを作成
    const newTeam = await api.teams.create();
    // 2. Cognitoユーザーを作成
    const newCognitoUser = await utils.amplify.signUp(
      value.email,
      value.password
    );

    const birthdate = resources.users.getBirthDate(
      value.birthyear,
      value.birthmonth,
      value.birthday
    );

    // 3. DBのユーザーを作成
    const b: UserCreateBody = {
      teamId: newTeam.id,
      sub: newCognitoUser.userSub,
      cognitoUserName: newCognitoUser.userSub,
      email: value.email,
      lastName: value.lastName,
      firstName: value.firstName,
      lastKana: value.lastKana,
      firstKana: value.firstKana,
      prefecture: value.prefecture,
      phoneNumber: value.phoneNumber,
      authLevel: constants.AUTHORITIES.SUPER_ADMIN,
      organization: value.organization,
      position: value.position,
      gender: value.gender,
      birthdate,
    };

    await api.users.create(b);

    props.history.push(paths.signUp.thank);
  } catch (err) {
    // SNSログインで登録しているメールアドレスと重複している場合エラーにする
    switch (err.response.data.message) {
      case 'An account with the given email already exists.':
        notify(constants.ERRORS.EXISTED_EMAIL, 'error');
        break;
      default: {
        notify(constants.ERRORS.UNKNWON, 'error');
      }
    }
  } finally {
    formikAction.setSubmitting(false);
  }
};
